// extracted by mini-css-extract-plugin
export default {"root":"djN__b","group":"_a1eGI","groupTitle":"WwXnUp","specList":"ti35X3","specItem":"SSVxh6","specTitle":"czFdVW","specValue":"RN1jhY"};